import React from 'react';
export var defaultValue = {
  value: null,
  error: null,
  loading: true
};
var InstallationContext = React.createContext(defaultValue);
export default InstallationContext;